import { Component, inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from "@angular/material/snack-bar";

import { faCircleCheck, IconDefinition, faExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { CommonModule } from "@angular/common";
import { SnackData } from "../../model/snack-notification-model";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  imports: [CommonModule, MatSnackBarModule, FontAwesomeModule, TranslatePipe],
  templateUrl: "./custom-wrapper-component.html",
  styleUrl: "./custom-wrapper-component.scss"
})
export class CustomWrapperComponent {
  public iconMap: Record<string, IconDefinition> = {
    faCircleCheck: faCircleCheck,
    faExclamation: faExclamation
  };
  public snackRef = inject(MatSnackBarRef<CustomWrapperComponent>);
  public data = inject<SnackData>(MAT_SNACK_BAR_DATA);
}
